import { Tab } from '@/features/ui/navigation'
import Badge from '@/features/ui/navigation/Tab/parts/Badge'
import { BadgeSlotProps } from '@/features/ui/navigation/Tab/types'
import { FC, useCallback } from 'react'
import { Pressable, StyleSheet } from 'react-native'

interface TabButtonProps {
    active: boolean
    count: number
    label: string
    onPress: () => void
}

const TabButton: FC<TabButtonProps> = ({ active, count, label, onPress }) => {
    const CountBadge = useCallback(
        ({ active }: BadgeSlotProps) => <Badge inverted={!active}>{String(count)}</Badge>,
        [count]
    )

    return (
        <Pressable
            accessibilityRole="tab"
            accessibilityLabel={label}
            aria-selected={active}
            onPress={onPress}
            style={({ pressed }) => [styles.container, pressed && styles.pressed]}
        >
            <Tab active={active} Badge={CountBadge}>
                {label}
            </Tab>
        </Pressable>
    )
}

const styles = StyleSheet.create({
    container: { minHeight: 36, justifyContent: 'center' },
    pressed: { opacity: 0.72 },
})

export default TabButton
